// @flow

import * as React from 'react';
import styled from 'styled-components';
import { Box } from '@latitude/box';
import { Heading4 } from '@latitude/heading';
import { FramedContainer } from '@latitude/framed-container';
import { Text } from '@latitude/text';
import {
  BREAKPOINT,
  MARGIN,
  ALIGN,
  COLOR,
  PADDING,
  TEXT_VARIANT,
  FONT_SIZE
} from '@latitude/core/utils/constants';

type Props = {
  /** Specify a unique id for the HTML element. */
  id?: string,
  /** The section heading. */
  heading?: string,
  /** The section subheading. */
  subheading?: string,
  /** The child elements of the component. */
  children?: React.Node
};

const OuterContainer = styled(Box)`
  padding: ${PADDING.P48} ${PADDING.P16};
  background-color: ${COLOR.GREY6};
`;

const Heading = styled(Heading4)`
  text-align: ${ALIGN.CENTER};
  color: ${COLOR.BLACK};
  ${({ subheading }: { subheading: boolean }) =>
    subheading
      ? `margin-bottom: ${MARGIN.M8};`
      : `margin-bottom: ${MARGIN.M24};
         @media (min-width: ${BREAKPOINT.SM}) {
           margin-bottom: ${MARGIN.M40};
         }`};
`;

const Subheading = styled(Text)`
  text-align: ${ALIGN.CENTER};
  color: ${COLOR.GREY75};
  margin: 0 auto ${MARGIN.M24};
  max-width: 750px;
  @media (min-width: ${BREAKPOINT.SM}) {
    margin-bottom: ${MARGIN.M32};
  }
`;

const ConfettiContainer = styled(Box)`
  border: solid 1px transparent;
  margin: 0 auto;
  width: 100%;
  max-width: 1250px;
  @media (min-width: ${BREAKPOINT.XL}) {
    background-position: left center, right center;
    background-repeat: no-repeat, no-repeat;
    background-size: 229px 440px, 193px 440px;
  }
`;

const InnerContainer = styled(Box)`
  margin: 0 auto;
  width: 100%;
  max-width: 700px;
  min-height: 440px;
`;

const ConfettiFramedContainerKiwibank = ({
  id,
  heading,
  subheading,
  children
}: Props) => (
  <OuterContainer id={id}>
    {heading && <Heading subheading={!!subheading}>{heading}</Heading>}
    {subheading && (
      <Subheading variant={TEXT_VARIANT.DIV} fontSize={FONT_SIZE.LARGE}>
        {subheading}
      </Subheading>
    )}
    <ConfettiContainer>
      <InnerContainer>
        <FramedContainer minHeight="320px">{children}</FramedContainer>
      </InnerContainer>
    </ConfettiContainer>
  </OuterContainer>
);

export default ConfettiFramedContainerKiwibank;
